<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <CRow>
        <CCol cols="12" md="12" lg="12">
          <!-- <b-button variant="primary" class="mb-4" v-b-modal.modal-input-mitra>
            <CIcon name="cil-plus" />
            {{ $store.state.table.tambahModal }}
          </b-button> -->
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
            <template #Actions="{ item }">
              <td>
                <b-button variant="warning" class="mr-1" v-c-tooltip.hover.click="$store.state.table.tooltipEdit" v-b-modal.modal-edit-mitra @click="(data = item), (edit = !edit)"
                  ><CIcon name="cil-pencil" /> {{ item.actions }}</b-button
                >
                <b-button variant="danger" class="mr-1" v-c-tooltip.hover.click="$store.state.table.tooltipHapus" v-b-modal.modal-delete-mitra @click="data = item"
                  ><CIcon name="cil-trash" /> {{ item.actions }}</b-button
                >
              </td>
            </template>
          </CDataTable>
          <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
        </CCol>
      </CRow>
    </CCol>
    <modal-input @alertFromChild="triggerAlert($event)" />
    <modal-edit :data="data" @alertFromChild="triggerAlert($event)" />
    <modal-delete :data="data" @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalInput from "./modalInputMitra.vue";
import modalEdit from "./modalEditMitra.vue";
import modalDelete from "./modalDeleteMitra.vue";

export default {
  components: {
    modalInput,
    modalEdit,
    modalDelete,
  },
  props: ["activeTab"],
  name: "Posisi",
  data() {
    return {
      edit: false,
      divisi: [],
      data: {},
      items: [],

      filter: {},
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      return [
        // {
        //   key: "no",
        //   label: "No",
        //   sortDirection: "desc",
        //   _classes: "table-number text-center ",
        //   _style: "width: 1px;",
        //   filter: false,
        //   sorter: false,
        // },
        {
          key: "namaApp",
          label: "Nama APP",
          _style: "width: 20%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaMitra",
          label: "Nama Mitra",
          _style: "width: 25%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        // {
        //   key: "tanggalGaji",
        //   label: "Tanggal Gajian",
        //   _style: "width: 10%;",
        //   sortDirection: "desc",
        //   _classes: "text-left",
        //   sorter: false,
        // },
        // {
        //   key: "tanggalClosing",
        //   label: "Tanggal Tutup Buku",
        //   _style: "width: 10%;",
        //   sortDirection: "desc",
        //   _classes: "text-left",
        //   sorter: false,
        // },
        {
          key: "bebanTenagaKerjaPerusahaan",
          label: "BPJS Ketenagakerjaan (%)",
          _style: "width: 10%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "bebanKesehatanPerusahaan",
          label: "BPJS Kesehatan (%)",
          _style: "width: 10%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: "Actions",
          _style: "width: 10%",
          _classes: "text-center",
          filter: false,
          sorter: false,
        },
      ];
    },
  },
  mounted() {
    this.getDatas();
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    activeTab: function (newVal) {
      if (newVal == 0) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listMitra = await vm.$axios.post("mitra/listPerHalaman", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
        mitraId: null,
      });
      // console.log("listMitra", listMitra);
      vm.items =
        listMitra.data.status == 200
          ? listMitra.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
              };
            })
          : [];
      vm.totalRows = parseInt(listMitra.data.count);
      vm.loading = false;
    },
    triggerAlert(event) {
      let vm = this;
      vm.getDatas();
      vm.$store.commit("set_alert", event);
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
